import * as React from "react";
import styled from "styled-components";
import { getHealthStatusColor } from "health/HealthStatusIcon";
import { STATUS_LABELS } from "health/healthStatusCopy";
import { STATUS_PRESETS } from "./types";
const StatusItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacings.xxs};
`;
const StatusDot = styled.span(
  ({ theme, $status }) => `
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${getHealthStatusColor($status, theme)};
  `
);
const PresetLabel = ({ preset }) => {
  const statuses = STATUS_PRESETS[preset];
  return /* @__PURE__ */ React.createElement(StatusItem, null, statuses.map((status) => /* @__PURE__ */ React.createElement(StatusDot, { key: status, $status: status })), statuses.map((status) => STATUS_LABELS[status]).join(" or "));
};
const STATUS_OPTIONS = Object.keys(STATUS_PRESETS).map((preset) => ({ value: preset, label: /* @__PURE__ */ React.createElement(PresetLabel, { preset }) }));
export default STATUS_OPTIONS;
